<template>
  <div class="d-flex col-12 p-5">
    <!-- <div class="card-header d-flex justify-content-between">
      <div></div>
      <h4 class="card-title fw-bold py-3 m-0">Add Crime to Charges</h4> 
      <button class="btn btn-primary" @click="close"><i class="fa fa-close"></i></button>
    </div> -->
    <div class="fs-5 d-flex flex-column" v-if="!loading && !multipleCharges">
      <h4 class="mb-3" v-if="crime">
        <div class="d-flex w-100 fs-5">
          <span class="fw-bold">{{ crime.codeDefinitionCode }} {{ crime.statuteDefinitionSection }}:</span>
          <span class="ml-1">{{ crime.Name }} ({{ crime.crmSeverityName }})</span>
        </div>
      </h4>
      <div v-if="CrimeFactors?.length > 0" class="mb-3">
        <!-- <h4 class="fw-bold mb-3">Select one of the following:</h4> -->
        <h4 class="fs-5 fw-bold">{{ CPKGroup?.PromptMessage }}</h4>
        <ul class="p-0 m-0">
          <li
            class="list-style-none d-flex p-0 ml-0 align-items-center"
            v-for="crimeFactor in CrimeFactors"
            :key="crimeFactor.FactorId"
          >
            <input
              type="radio"
              :id="crimeFactor.CrimeId"
              name="Factor"
              :value="crimeFactor.CrimeId"
              v-model="selectedCrimeId"
            />
            <label class="p-0 ml-3 mb-0 fs-5" :for="crimeFactor.CrimeId">{{ crimeFactor.FactorName }} </label>
          </li>
        </ul>
      </div>
      <!-- ENHANCEMENT MATCHES -->
      <div
        class="d-flex mb-3"
        v-if="crime !== null && (crime.CrimeTypeId == 2 || crime.CrimeTypeId == 6) && eligibleParentCharges?.length > 0"
      >
        <div v-if="charges?.length > 0" class="d-flex flex-column">
          <h4 class="fw-bold mb-3 fs-5">
            Select a Charge to attach this
            <span v-if="crime.CrimeTypeId == 6">enhancement</span><span v-else>allegation</span> to:
          </h4>
          <select class="form-control" v-model="CountNumber">
            <option
              v-for="charge in eligibleParentCharges"
              :key="charge.Id"
              :value="charge.CountNumber"
              :minimum="minCountNumber"
              :max="maxCountNumber"
            >
              {{ charge.CountNumber }}. {{ charge.SectionNumber }} ({{ charge.Name }})
            </option>
          </select>
        </div>
        <div v-else>
          <h4 class="fw-bold mb-3">You have no Charges to attach this to.</h4>
        </div>
        <div class="d-flex flex-column" v-if="crime && crime.CrimeTypeId == 2">
          <div class="d-flex flex-column ml-5 p-0">
            <!-- <label for="CrimeState" class="fw-bold fs-5">Severity</label> -->
            <div class="d-flex mt-4">
              <input type="radio" name="CrimeState" id="Completed" v-model="CrimeState" value="Completed" default />
              <label class="fs-5 ml-3" for="Completed">Completed</label>
            </div>
            <div class="d-flex">
              <input type="radio" name="CrimeState" id="Attempt" v-model="CrimeState" value="Attempt" />
              <label class="fs-5 ml-3" for="Attempt">Attempt</label>
            </div>
            <div class="d-flex">
              <input type="radio" name="CrimeState" id="Conspiracy" v-model="CrimeState" value="Conspiracy" />
              <label class="fs-5 ml-3" for="Conspiracy">Conspiracy</label>
            </div>
          </div>
        </div>
      </div>
      <!-- COUNT PANEL -->
      <div class="d-flex flex-column w-100" v-else-if="crime && crime.CrimeTypeId == 5">
        <!-- <h4 class="fw-bold mt-5 mb-5 fs-5">
          Select a count number and whether the crime was completed
        </h4> -->
        <div class="d-flex w-100 flex-wrap">
          <div class="d-flex flex-column mr-5 p-0" v-if="insertChargeCountNumber === null">
            <label for="CountNumber" class="fw-bold fs-5">Count</label>
            <input
              style="width: 75px"
              type="number"
              name="CountNumber"
              class="form-control fs-5 mb-5"
              v-model="CountNumber"
              @input="validateCountNumber"
            />
          </div>
          <div class="d-flex flex-column p-0">
            <div v-if="insertChargeCountNumber !== null">
              <p class="fw-bold fs-5">Count {{ insertChargeCountNumber }}</p>
            </div>
            <!-- <label for="CrimeState" class="fw-bold fs-5">Severity</label> -->
            <div class="d-flex">
              <input type="radio" name="CrimeState" id="Completed" v-model="CrimeState" value="Completed" default />
              <label class="fs-5 ml-3" for="Completed">Completed</label>
            </div>
            <div class="d-flex">
              <input type="radio" name="CrimeState" id="Attempt" v-model="CrimeState" value="Attempt" />
              <label class="fs-5 ml-3" for="Attempt">Attempt</label>
            </div>
            <div class="d-flex">
              <input type="radio" name="CrimeState" id="Conspiracy" v-model="CrimeState" value="Conspiracy" />
              <label class="fs-5 ml-3" for="Conspiracy">Conspiracy</label>
            </div>
          </div>
        </div>
        <!-- <div class="d-flex flex-column align-items-center mt-5">
          <p class="fs-5 fw-bold">Add {{ crime.codeDefinitionCode }} {{ crime.statuteDefinitionSection }}</p>
          <div class="border p-5 d-flex">
            <div class="d-flex flex-column">
              <button class="btn btn-primary  btn-xl" @click="addCharge">Single Count</button>
            </div>
            <div class="d-flex flex-column">
              <button class="btn btn-primary-outline  ml-3 btn-xl" @click="toggleMultipleMode">Multiple Counts</button>
            </div>
          </div>
        </div> -->

        <div>
          <button class="btn btn-primary mt-5 btn-xl" @click="addCharge">Add Charge</button>
          <button
            class="btn btn-primary-outline mt-5 ml-3 btn-xl"
            @click="toggleMultipleMode"
            v-if="insertChargeCountNumber === null"
          >
            Add Multiple {{ crime.codeDefinitionCode }}
            {{ crime.statuteDefinitionSection }}
          </button>
        </div>
      </div>
      <div v-if="crime?.CrimeTypeId !== 5 && eligibleParentCharges?.length > 0">
        <button class="btn btn-primary btn-xl" @click="addCharge">Add Charge</button>
        <button class="btn btn-primary-outline ml-3 btn-xl" @click="toggleMultipleMode">
          Add Multiple {{ crime.codeDefinitionCode }} {{ crime.statuteDefinitionSection }}
        </button>
      </div>
      <div class="d-flex flex-column w-100" v-else-if="crime?.CrimeTypeId !== 5 && !loading">
        <h3 class="my-3 fs-5">This charge cannot be added to this case.</h3>
        <!-- <div class="d-flex flex-column">
          <h3>This enhancement can only be added to one of the following crimes:</h3>
          <div  v-html="enhancementMatchGroupHelperText"></div>
        </div> -->
        <div class="d-flex w-100 justify-content-center">
          <div>
            <button class="btn btn-primary btn-xl" @click="addCharge">Add and Stay Charge</button>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column" v-else-if="!loading && crime">
      <h4 class="mb-5" v-if="crime">
        <div class="d-flex w-100 fs-5">
          <span class="pr-4 fw-bold">{{ crime.codeDefinitionCode }} {{ crime.statuteDefinitionSection }}</span>
          <span>{{ crime.Name }} ({{ crime.crmSeverityName }})</span>
        </div>
      </h4>
      <div v-if="crime.CrimeTypeId !== 6 && crime.CrimeTypeId !== 2">
        <table class="border-bottom border-right border-left w-100">
          <thead>
            <!-- style="table-layout: fixed; width: 100%;" -->

            <tr>
              <!-- <th>Count</th> -->
              <th class="fs-5" v-if="crime.CrimeTypeId == 5">Count</th>
              <th class="fs-5">Section</th>
              <th class="fs-5">Description</th>
              <th class="fs-5" v-if="crime.CrimeTypeId == 5">Severity</th>
              <th class="fs-5" v-if="crime.CrimeTypeId == 5">Date</th>
              <th class="fs-5" v-if="crime.CrimeTypeId == 5">Completed</th>
              <th class="fs-5" v-if="crime.CrimeTypeId == 5 && CrimeFactors?.length > 0">
                {{ CPKGroup?.PromptMessage }}
              </th>
              <th class="fs-5"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(chargeToAdd, i) in chargesToAdd" :key="i">
              <!-- <td>{{ crime.currentCount }}</td> -->
              <td class="pl-3" v-if="crime.CrimeTypeId == 5">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="pr-3">
                    {{ chargeToAdd.currentCount }}
                  </span>
                  <div class="d-flex flex-column" style="width: 30px">
                    <i @click="increaseCountNumber(chargeToAdd)" class="fa fa-arrow-up button-color clickable mb-2"></i>
                    <i
                      @click="decreaseCountNumber(chargeToAdd, chargeToAdd.currentCount)"
                      class="fa fa-arrow-down button-color clickable"
                    ></i>
                  </div>
                </div>

                <!-- <input type="number" class="form-control" style="max-width: 100px" @input="validateMultipleChargeCountNumber(chargeToAdd)" v-model="chargeToAdd.currentCount" /> -->
              </td>
              <td v-if="!chargeToAdd?.selectedFactor?.CrimeStatuteDefinitionSection">
                {{ crime.codeDefinitionCode }} {{ crime.statuteDefinitionSection }}
              </td>
              <td v-else>
                {{ crime.codeDefinitionCode }}
                {{ chargeToAdd.selectedFactor.CrimeStatuteDefinitionSection }}
              </td>

              <td class="pl-3" v-if="!chargeToAdd?.selectedFactor?.CrimeName">
                {{ crime.Name }}
              </td>
              <td class="pl-3" v-else>
                {{ chargeToAdd.selectedFactor.CrimeName }}
              </td>
              <td class="pl-3" v-if="!chargeToAdd?.selectedFactor?.crmSeverityName && crime.CrimeTypeId == 5">
                ({{ crime.crmSeverityName }})
              </td>

              <td class="pl-3" v-else-if="crime.CrimeTypeId == 5">
                {{ chargeToAdd.selectedFactor.crmSeverityName }}
              </td>

              <td class="pl-3" v-if="crime.CrimeTypeId == 5">
                <input
                  type="date"
                  class="form-control"
                  v-model="chargeToAdd.Date"
                  @input="validateDateChange(chargeToAdd)"
                />
              </td>
              <td class="pl-3" v-if="crime.CrimeTypeId == 5">
                <select v-model="chargeToAdd.CrimeState" class="form-control">
                  <option value="Completed">Completed</option>
                  <option value="Attempt">Attempt</option>
                  <option value="Conspiracy">Conspiracy</option>
                </select>
              </td>
              <td class="pl-3" v-if="CrimeFactors?.length > 0">
                <select class="form-control" v-model="chargeToAdd.selectedFactor">
                  <option v-for="factor in CrimeFactors" :key="factor.Id" :value="factor">
                    {{ factor.FactorName }}
                  </option>
                </select>
              </td>
              <td class="pl-3">
                <button v-if="i > 1" class="btn btn-primary-outline" @click="removeChargeFromChargesToAdd(chargeToAdd)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td class="pl-3 ta-c" colspan="8" v-if="crime.CrimeTypeId == 5 && CrimeFactors?.length > 0">
                <button class="btn btn-primary" @click="addChargeToChargesToAdd">
                  <i class="fa fa-plus"></i> Add Another {{ crime.codeDefinitionCode }}
                  {{ crime.statuteDefinitionSection }}
                </button>
              </td>
              <td class="pl-3 ta-c" colspan="7" v-else-if="crime.CrimeTypeId == 5">
                <button class="btn btn-primary" @click="addChargeToChargesToAdd">
                  <i class="fa fa-plus"></i> Add Another {{ crime.codeDefinitionCode }}
                  {{ crime.statuteDefinitionSection }}
                </button>
              </td>
              <td class="pl-3 ta-c" colspan="3" v-else>
                <button class="btn btn-primary" @click="addChargeToChargesToAdd">
                  <i class="fa fa-plus"></i> Add Another {{ crime.codeDefinitionCode }}
                  {{ crime.statuteDefinitionSection }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else-if="crime.CrimeTypeId == 6 || crime.CrimeTypeId == 2">
        <table class="border-left border-right border-bottom">
          <thead>
            <tr>
              <th class="fs-5">Section</th>
              <th class="fs-5">Description</th>
              <th class="fs-5">Offense Date</th>
              <th class="fs-5">Designated Charge</th>
              <th class="fs-5" v-if="crime.CrimeTypeId == 2">Completed</th>
              <th class="fs-5"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="charge in chargesToAdd" :key="charge.TempId">
              <td>{{ crime.codeDefinitionCode }} {{ crime.statuteDefinitionSection }}</td>
              <td>{{ crime.Name }}</td>
              <td>
                {{
                  createMoment(eligibleParentCharges.find((c) => c.CountNumber == charge.currentCount).Date).format(
                    "MM/DD/YYYY"
                  )
                }}
              </td>
              <td>
                <select class="form-control" v-model="charge.currentCount">
                  <option
                    v-for="parentCharge in eligibleParentCharges"
                    :value="parentCharge.CountNumber"
                    :key="parentCharge.Id"
                  >
                    Count {{ parentCharge.CountNumber }}.
                    {{ parentCharge.codeDefinitionCode }}
                    {{ parentCharge.statuteDefinitionSection }}
                  </option>
                </select>
              </td>
              <td v-if="crime.CrimeTypeId == 2">
                <select class="form-control" v-model="charge.CrimeState">
                  <option value="Completed">Completed</option>
                  <option value="Attempt">Attempt</option>
                  <option value="Conspiracy">Conspiracy</option>
                </select>
              </td>
              <td>
                <button class="btn btn-primary-outline" @click="removeChargeFromChargesToAdd(charge)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center pt-3">
        <button class="btn btn-primary mr-3" @click="createAllChargesToAdd">Add All Charges</button>
        <button class="btn btn-primary-outline" @click="toggleMultipleMode">Back</button>
      </div>
      <p style="height: 1rem" class="error ta-c" v-if="errorText.length > 0">
        {{ errorText }}
      </p>
      <p style="height: 1rem" v-else></p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handleError } from "../../helpers";
import { v4 as randomUUID } from "uuid";
import moment from "moment";
export default {
  name: "AddChargeModal",
  props: ["charges", "crimeIdToAdd", "bDate", "eDate", "insertChargeCountNumber"],
  data() {
    return {
      token: null,
      crime: null,
      CPKGroup: null,
      CrimeFactors: null,
      selectedFactorId: null,
      CrimeState: "Completed",
      CountNumber: 0,
      // enhancementMatchedCharges: [],
      factors: [],
      loading: true,
      enhancementMatchGroups: [],
      multipleCharges: false,
      chargesToAdd: [],
      crimeToAddEMGIds: [],
      errorText: "",
      crimeToAddEnhancementMatchGroups: [],
    };
  },
  methods: {
    // Your methods go here
    async getCrime() {
      return axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/crimes/" + this.crimeIdToAdd, {
          headers: { Authorization: `Bearer ` + this.token },
        })
        .then((res) => {
          return res.data;
        })
        .catch(handleError);
    },
    async getCrimeCPKGroup() {
      if (this.crime && this.crime.CrimeTypeId == 5) {
        const CPKGroup = await axios
          .get(process.env.VUE_APP_ENDPOINT + "/api/vCrimeCPKGroup/getManyByCrimeId/" + this.crime.Id, {
            headers: { Authorization: `Bearer ` + this.token },
          })
          .then((data) => {
            return data.data;
          })
          .catch(handleError);
        if (CPKGroup?.length > 0) {
          return CPKGroup[0];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    async getFactors() {
      const crimeFactors = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/crimeFactorCPKGroup/getManyByCPKGroupId/" + this.CPKGroup?.Id, {
          headers: { Authorization: `Bearer ` + this.token },
        })
        .then((data) => {
          return data.data;
        })
        .catch(handleError);
      this.loading = false;
      return crimeFactors.sort((a, b) => a.SortValue - b.SortValue);
    },

    setDefaultFactor() {
      let selectedFactor = this.factors.findIndex((x) => x.CrimeId == this.crimeIdToAdd);

      if (selectedFactor > -1) {
        this.selectedCrimeId = this.CrimeFactors[selectedFactor].CrimeId;
      } else {
        let closestFactor = this.CrimeFactors.findIndex((x) => x.CrimeName == this.crime.Name);
        if (closestFactor > -1) {
          this.selectedCrimeId = this.CrimeFactors[closestFactor].CrimeId;
        } else {
          this.selectedCrimeId = this.CrimeFactors[0]?.CrimeId;
        }
      }
    },
    close() {
      this.$emit("closeAddChargeModal");
    },
    createMoment(date) {
      return moment(date);
    },
    validateCountNumber() {
      if (this.CountNumber !== null) {
        if (this.crime.CrimeTypeId == 1 || this.crime.CrimeTypeId == 2) {
          this.minCountNumber = 0;
          this.maxCountNumber = 0;
        }
        if (this.crime.CrimeTypeId == 5) {
          this.minCountNumber = 1;

          if (this.charges.length == 0 && this.CountNumber == 0) {
            this.CountNumber = 1;
          } else if (this.CountNumber == 0) {
            let unoccupied = 1;
            let crimeCharges = this.charges.filter((chg) => chg.CrimeTypeId == 5);
            let countNumbers = [];
            crimeCharges.forEach((chg) => {
              if (!countNumbers.includes(chg.CountNumber)) {
                countNumbers.push(chg.CountNumber);
              }
            });
            countNumbers.sort((a, b) => a - b);
            for (let i = 0; i < countNumbers.length; i++) {
              if (countNumbers[i] != unoccupied) {
                this.CountNumber = unoccupied;
                break;
              } else {
                unoccupied++;
              }
            }
            this.CountNumber = unoccupied;
          } else if (this.CountNumber !== 0) {
            let crimeCharges = this.charges.filter((chg) => chg.CrimeTypeId == 5);
            let countNumbers = crimeCharges.map((chg) => chg.CountNumber);
            if (countNumbers.includes(this.CountNumber)) {
              this.CountNumber++;
              this.validateCountNumber();
            }
          }
        }
      } else if (this.crime.CrimeTypeId == 1 || this.crime.CrimeTypeId == 3) {
        this.minCountNumber = 0;
        this.maxCountNumber = 0;
        this.CountNumber = 0;
      }
    },
    addCharge() {
      const charge = {
        crimeId: this.crime.Id,
        currentCount: this.insertChargeCountNumber === null ? this.CountNumber : this.insertChargeCountNumber,
        CrimeState: this.CrimeState,
        isEnhancementMatch: true,
        ChargedPer: null,
      };
      if (this.CrimeFactors?.length > 0) {
        charge.crimeId = this.selectedCrimeId;
        charge.ChargedPer = this.crimeIdToAdd;
      }
      this.$emit("addCharge", charge, true);
    },
    async getEnhancementMatchGroups(charge, crimeId) {
      const search = charge?.CrimeId ?? crimeId;

      this.crimeToAddEnhancementMatchGroups = await axios
        .get(process.env.VUE_APP_ENDPOINT + `/api/crimeEnhancementMatchGroup/getManyByCrimeId/${search}`, {
          headers: {
            Authorization: `Bearer ` + localStorage.getItem("user_token"),
          },
        })
        .then((result) => {
          return result.data;
        })
        .catch(handleError);
      return this.crimeToAddEnhancementMatchGroups;
      // const matchesOnCrime = enhMatches.map((emg) => emg.EnhancementMatchGroupId);

      // return matchesOnCrime;
    },
    emitErrorText(text) {
      this.errorText = text;
      setTimeout(() => {
        this.errorText = "";
      }, 3000);
    },

    async getCrimeEnhancementMatchGroups() {
      let enhancementMatchGroups = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/enhancementmatchgroup/getManyByCrimeId/" + this.crime.Id, {
          headers: { Authorization: `Bearer ` + this.token },
        })
        .then((res) => res.data)
        .catch((e) => handleError(e));
      this.enhancementMatchGroups = enhancementMatchGroups;
    },
    toggleMultipleMode() {
      if (!this.multipleCharges && this.chargesToAdd.length == 0) {
        if (this.crime.CrimeTypeId == 5) {
          this.chargesToAdd.push({
            crimeId: this.crime.Id,
            currentCount: this.CountNumber,
            CrimeState: this.CrimeState,
            isEnhancementMatch: true,
            ChargedPer: null,
            selectedFactor: null,
            TempId: randomUUID(),
            Date: this.bDate,
          });
          this.CountNumber++;
          this.validateCountNumber();
          this.chargesToAdd.push({
            crimeId: this.crime.Id,
            currentCount: this.CountNumber,
            CrimeState: this.CrimeState,
            isEnhancementMatch: true,
            ChargedPer: null,
            selectedFactor: null,
            TempId: randomUUID(),
            Date: this.bDate,
          });
          if (this.CrimeFactors?.length > 0) {
            this.chargesToAdd.forEach((crime) => {
              let bestFactor = this.CrimeFactors.findIndex((factor) => factor.CrimeId == crime.Id);
              if (bestFactor !== -1) {
                crime.selectedFactor = this.CrimeFactors[bestFactor];
              } else {
                let closestFactor = this.CrimeFactors.findIndex((x) => x.CrimeName == this.crime.Name);
                if (closestFactor > -1) {
                  crime.selectedFactor = this.CrimeFactors[closestFactor];
                } else {
                  crime.selectedFactor = this.CrimeFactors[0];
                }
              }
            });
          }
        } else if (this.crime.CrimeTypeId !== 1 && this.crime.CrimeTypeId !== 3) {
          this.eligibleParentCharges.forEach((parentCharge, i) => {
            this.chargesToAdd.push({
              currentCount: parentCharge.CountNumber,
              CrimeState: this.crime.CrimeTypeId != 6 ? parentCharge?.CrimeState : "Completed",
              isEnhancementMatch: true,
              ChargedPer: null,
              TempId: randomUUID(),
              crimeId: this.crime.Id,
              Date: this.bDate,
            });
          });
        } else if (this.crime.CrimeTypeId == 1 || this.crime.CrimeTypeId == 3) {
          this.chargesToAdd.push({
            currentCount: 0,
            CrimeState: "Completed",
            isEnhancementMatch: true,
            ChargedPer: null,
            TempId: randomUUID(),
            crimeId: this.crime.Id,
            Date: this.bDate,
          });
          this.chargesToAdd.push({
            currentCount: 0,
            CrimeState: "Completed",
            isEnhancementMatch: true,
            ChargedPer: null,
            TempId: randomUUID(),
            crimeId: this.crime.Id,
            Date: this.bDate,
          });
        }
      }

      this.multipleCharges = !this.multipleCharges;
    },
    validateDateChange(chargeToValidate) {
      if (moment(chargeToValidate.Date).isBefore(this.crime.BeginDate)) {
        chargeToValidate.Date = this.crime.BeginDate;

        this.emitErrorText("Date must be after the crime's effective date.");
        return false;
      }
    },
    // validateMultipleChargeCountNumber(chargeToValidate) {
    //   if (this.crime.CrimeTypeId == 5) {
    //     let foundIndexInExistingCharges = this.charges.findIndex(charge => charge.CountNumber == chargeToValidate.currentCount);
    //     if (foundIndexInExistingCharges !== -1) {
    //       chargeToValidate.currentCount++;
    //       this.validateMultipleChargeCountNumber(chargeToValidate);
    //     }
    //     let foundIndexInChargesToAdd = this.chargesToAdd.findIndex(charge => charge.currentCount == chargeToValidate.currentCount && charge.TempId != chargeToValidate.TempId);
    //     if (foundIndexInChargesToAdd !== -1) {
    //       chargeToValidate.currentCount++;
    //       this.validateMultipleChargeCountNumber(chargeToValidate);
    //     }
    //   }
    // },
    increaseCountNumber(chargeToValidate) {
      chargeToValidate.currentCount++;
      if (this.crime.CrimeTypeId == 5) {
        let foundIndexInExistingCharges = this.charges.findIndex(
          (charge) => charge.CountNumber == chargeToValidate.currentCount
        );
        if (foundIndexInExistingCharges !== -1) {
          // chargeToValidate.currentCount++;
          this.increaseCountNumber(chargeToValidate);
        }
        let foundIndexInChargesToAdd = this.chargesToAdd.findIndex(
          (charge) => charge.currentCount == chargeToValidate.currentCount && charge.TempId != chargeToValidate.TempId
        );
        if (foundIndexInChargesToAdd !== -1) {
          // chargeToValidate.currentCount++;
          this.increaseCountNumber(chargeToValidate);
        } else {
          this.chargesToAdd.sort((a, b) => a.currentCount - b.currentCount);
        }
      }
    },
    decreaseCountNumber(chargeToValidate, originalCountNumber) {
      chargeToValidate.currentCount--;
      if (chargeToValidate.currentCount == 0) {
        chargeToValidate.currentCount = originalCountNumber;
        this.emitErrorText("No lower count numbers available.");
        return;
      }
      if (this.crime.CrimeTypeId == 5) {
        let foundIndexInExistingCharges = this.charges.findIndex(
          (charge) => charge.CountNumber == chargeToValidate.currentCount
        );
        if (foundIndexInExistingCharges !== -1) {
          this.decreaseCountNumber(chargeToValidate, originalCountNumber);
        }
        let foundIndexInChargesToAdd = this.chargesToAdd.findIndex(
          (charge) => charge.currentCount == chargeToValidate.currentCount && charge.TempId != chargeToValidate.TempId
        );
        if (foundIndexInChargesToAdd !== -1) {
          this.decreaseCountNumber(chargeToValidate, originalCountNumber);
        } else {
          this.chargesToAdd.sort((a, b) => a.currentCount - b.currentCount);
        }
      }
    },
    addChargeToChargesToAdd() {
      const newChargeToAdd = {
        crimeId: this.crime.Id,
        currentCount: this.CountNumber,
        CrimeState: this.CrimeState,
        isEnhancementMatch: true,
        ChargedPer: null,
        selectedFactor: null,
        TempId: randomUUID(),
        Date: this.bDate,
      };
      this.chargesToAdd.push(newChargeToAdd);
      if (this.crime.CrimeTypeId == 5) {
        this.increaseCountNumber(this.chargesToAdd[this.chargesToAdd.length - 1]);
      }
      if (this.CrimeFactors?.length > 0) {
        let newIndex = this.chargesToAdd.findIndex((charge) => charge.TempId == newChargeToAdd.TempId);
        let bestFactor = this.CrimeFactors.findIndex((factor) => factor.CrimeId == this.crime.Id);
        if (bestFactor !== -1) {
          this.chargesToAdd[newIndex].selectedFactor = this.CrimeFactors[bestFactor];
        } else {
          let closestFactor = this.CrimeFactors.findIndex((x) => x.CrimeName == this.crime?.Name);
          if (closestFactor > -1) {
            this.chargesToAdd[newIndex].selectedFactor = this.CrimeFactors[closestFactor];
          } else {
            this.chargesToAdd[newIndex].selectedFactor = this.CrimeFactors[0];
          }
        }
      }
    },
    removeChargeFromChargesToAdd(chargeToRemove) {
      let index = this.chargesToAdd.findIndex((charge) => charge.TempId == chargeToRemove.TempId);
      this.chargesToAdd.splice(index, 1);
    },
    createAllChargesToAdd() {
      const mappedCharges = this.chargesToAdd.map((charge) => {
        let returnObject = {
          crimeId: charge.crimeId,
          currentCount: charge.currentCount,
          CrimeState: charge.CrimeState,
          isEnhancementMatch: charge.isEnhancementMatch,
          OffenseDate: charge.Date,
        };
        // if (this.eDate) {
        //   returnObject.DateRangeEnd = this.eDate;
        // }
        if (charge?.selectedFactor?.CrimeId !== undefined) {
          returnObject.ChargedPer = this.crime.Id;
          returnObject.crimeId = charge.selectedFactor.CrimeId;
        }
        return returnObject;
      });
      mappedCharges.forEach((charge, i) => {
        this.$emit("addCharge", charge, i == mappedCharges?.length - 1, true);
      });
    },
  },
  computed: {
    enhancementMatchGroupHelperText() {
      let string = "";
      if (this.enhancementMatchGroups?.length > 0) {
        this.enhancementMatchGroups.forEach((emg) => {
          string += emg.HelperText + "\n\n";
        });
      }
      return string.split("</p><p>").join(", ");
    },
    eligibleParentCharges() {
      return this.charges.filter((charge) => {
        if (charge.CrimeTypeId !== 5) {
          return false;
        }
        if (this.crimeToAddEnhancementMatchGroups.length == 0) {
          return true;
        }
        let good = false;
        charge.EnhancementMatchGroups.forEach((emg) => {
          let foundIndex = this.crimeToAddEnhancementMatchGroups.findIndex((chargeToAddEMG) => {
            return (
              chargeToAddEMG.EnhancementMatchGroupId == emg.EnhancementMatchGroupId &&
              (charge.CrimeState != "Attempt" || chargeToAddEMG.AppliesToAttempts == true || emg.AppliesToAttempts == true)
            );
          });
          if (foundIndex !== -1) {
            good = true;
          }
          // if (this.crimeToAddEMGIds.includes(emg.EnhancementMatchGroupId)) {
          //   good = true;
          // }
        });
        return good;
      });
    },
  },
  async mounted() {
    this.token = localStorage.getItem("user_token");
    this.crime = await this.getCrime();
    if (this.crime.CrimeTypeId == 5) {
      this.CPKGroup = await this.getCrimeCPKGroup();
      if (this.CPKGroup) {
        this.CrimeFactors = await this.getFactors();
        this.setDefaultFactor();
      } else {
        this.loading = false;
      }
    } else {
      await this.getEnhancementMatchGroups(null, this.crime.Id);
      // this.filterChargesForEnhancementMatches();
      if (this.crime.CrimeTypeId == 6 || this.crime.CrimeTypeId == 2) {
        this.CountNumber = this.eligibleParentCharges[this.eligibleParentCharges.length - 1]?.CountNumber;
      } else {
        this.CountNumber = 0;
      }
      this.loading = false;
    }
    this.validateCountNumber();
  },
};
</script>

<style scoped>
.description-col {
  min-width: 200px;
}

select {
  font-size: 1rem;
}

:deep(select option) {
  font-size: 1rem;
}
</style>
